<template>
  <div
    v-if="model"
    class="fixed z-[9999] top-0 left-0 right-0 bottom-0 bg-gray-500/50 backdrop-blur px-[5vw] py-[10vh] md:p-[20vh] overflow-auto"
    @click.self="model = false"
    >
    <div
      class="flex items-center justify-center"
      @click.self="model = false"
      >
      <div
        class="w-[400px] aspect-video !p-2 ui-card"
        :class="$props.class"
        >
        <slot/>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
const emit = defineEmits(['opened', 'closed'])
defineProps<{
  class?: string
}>()

const model = defineModel<boolean>()

watch(model, (value) => {
  (value)
    ? emit('opened')
    : emit('closed')
})
</script>
